export default {
  skipToContent: "Перейти к содержимому",
  loading: "Загрузка…",
  error: "Произошла ошибка",
  retry: "Повторить",
  notFound: "Страница не найдена",
  notFoundHint: "Проверьте адрес или вернитесь на главную.",
  home: "На главную",
  save: "Сохранить",
  saved: "Сохранено",
  add: "Добавить",
  cancel: "Отмена",
  delete: "Удалить",
  create: "Создать",
  edit: "Изменить",
  close: "Закрыть",
  back: "Назад",
  yes: "Да",
  no: "Нет",
  more: "Подробнее",
  all: "Все",
  copy: "Копировать",
  copied: "Скопировано",
  download: "Скачать",
  open: "Открыть",
  confirm: "Подтвердить",
  required: "Обязательное поле",
  optional: "необязательно",
  empty: "Ничего не найдено",
  apply: "Применить",
  reset: "Сбросить",
  submit: "Отправить",
  language: "Язык",
  languageRu: "Русский",
  languageEn: "English",
  brandName: "НБР",
  brandFull: "Национальный библиографический ресурс",
  brandTagline: "Каталог по модели IFLA LRM: лица, произведения, издания, премии.",
  auth: {
    error: "Не удалось войти: {{message}}",
    redirecting: "Переход к авторизации…",
    finishing: "Завершаем вход…",
    forbidden: "Недостаточно прав для этой страницы.",
  },
  pager: {
    navigation: "Пагинация",
    previous: "Предыдущая страница",
    next: "Следующая страница",
    page: "Страница {{page}} из {{pages}}",
    total: "{{count}} записей",
  },
  footer: {
    portalTitle: "Портал",
    infoTitle: "О проекте",
    tagline: "Национальный библиографический ресурс — авторитетный каталог по модели IFLA LRM.",
    copyright: "© {{year}} Российская государственная библиотека. Национальный библиографический ресурс.",
    terms: "Пользовательское соглашение",
    personalDataConsent: "Согласие на обработку персональных данных",
    personalDataProcessingPolicy: "Политика обработки персональных данных",
    socialTitle: "Мы в социальных сетях",
    socialVk: "ВКонтакте",
    socialTelegram: "Telegram",
  },
  opensInNewTab: "откроется в новой вкладке",
  contactWidget: {
    aria: "Связаться с нами",
    title: "Связаться с нами",
    subtitle: "Напишите нам в Telegram или VK, и мы ответим в ближайшее время.",
  },
  landing: {
    heroTitle: "Национальный библиографический ресурс",
    heroAccent: "Знания в модели IFLA LRM",
    heroLead:
      "Авторитетный каталог лиц, произведений, изданий и премий. Ищите по фасетам, читайте связи и выгружайте цитирование.",
    openCatalog: "Открыть каталог",
    sparqlCta: "Подбор по условиям",
    statsTitle: "Каталог в цифрах",
    newsTitle: "Новости",
    allNews: "Все новости",
  },
  news: {
    title: "Новости",
    empty: "Пока нет опубликованных новостей.",
  },
  about: {
    title: "О проекте",
    fallback:
      "Национальный библиографический ресурс — портал Российской государственной библиотеки. Каталог построен по модели IFLA LRM: произведения, выражения, издания, лица, коллективные агенты, понятия и премии связаны типизированными отношениями и доступны через поиск, карточки и SPARQL.",
  },
  contactsPage: {
    kicker: "Связь с нами",
    title: "Контакты",
    writeUs: "Напишите нам",
    sentTitle: "Сообщение отправлено!",
    sentHint: "Мы ответим в течение 1–2 рабочих дней.",
    name: "Имя",
    email: "Email",
    subject: "Тема обращения",
    message: "Сообщение",
    send: "Отправить сообщение",
    address: "Адрес",
    phone: "Телефон",
    emailBlock: "Email",
    officialPages: "Официальные страницы",
    siteLabel: "Сайт Российской государственной библиотеки",
    socialNetworks: "Социальные сети",
    subjects: {
      general: "Общий вопрос",
      events: "Мероприятия",
      deposit: "Депонирование",
      tech: "Технические вопросы",
      coop: "Сотрудничество",
    },
  },
  legalPages: {
    agreementTitle: "Пользовательское соглашение",
    personalTitle: "Согласие на обработку персональных данных",
    privacyTitle: "Политика обработки персональных данных",
  },
}
